import { useCallback } from "react";
import { PowerOfAttorneyBillFormModal } from "@features/PowerOfAttorneyBillFormModal/PowerOfAttorneyBillFormModal";
import { useModalStore } from "@store/modal/modal";
import { usePOAStore } from "@store/poaStore/poaStore";

interface IPoaRequiredData {
  showExistingConsent?: boolean;
  powerOfAttorneyLedgerConsentId?: string;
  shouldFetchAllRecommendations?: boolean;
}

export const usePOAModal = () => {
  const { create } = useModalStore();
  const { reset } = usePOAStore();

  const openPOAModal = useCallback(
    (data: IPoaRequiredData) => {
      return create((modalProps) => (
        <PowerOfAttorneyBillFormModal
          important
          showExistingConsent={data.showExistingConsent}
          powerOfAttorneyLedgerConsentId={data.powerOfAttorneyLedgerConsentId}
          shouldFetchAllRecommendations={data.shouldFetchAllRecommendations}
          onClose={() => {
            reset();
          }}
          {...modalProps}
        />
      ));
    },
    [create, reset],
  );

  return { openPOAModal };
};
